import { useNavigate } from "react-router-dom";
import { PATH_LOGIN } from "@routes";
import { performLogoutActions } from "./logoutUtils";

export const useLogoutHandler = () => {
    const navigate = useNavigate();

    return async () => {
        await performLogoutActions();
        navigate(PATH_LOGIN);
    };
};
